module.exports = __webpack_public_path__ + "assets/chart2.1.png?3322131165f6454d02ba4afab503c58d";